import React, { PureComponent } from 'react';
import {
    LineChart,
    AreaChart,
    Area,
    CartesianGrid,
    Legend,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Line
} from "recharts";

const data = [
    {
        name: '9/11', uv: 30, pv: 23, amt: 2400,
    },
    {
        name: '9/10', uv: 34, pv: 13, amt: 2210,
    },
    {
        name: '9/9', uv: 28, pv: 54, amt: 2290,
    },
    {
        name: '9/8', uv: 13, pv: 32, amt: 2000,
    },
    {
        name: '9/7', uv: 21, pv: 20, amt: 2181,
    },
    {
        name: '9/6', uv: 36, pv: 16, amt: 2500,
    },
    {
        name: '9/5', uv: 30, pv: 27, amt: 2100,
    },
];


const CompletedCases = (props) => {

    return (
        //<ResponsiveContainer>
        //	<LineChart
        //		width={800}
        //		height={400}
        //	data={data}
        //>
        //	<CartesianGrid strokeDasharray="3 3" />
        //	<XAxis dataKey="name" interval="preserveEnd" />
        //	<YAxis interval="preserveEnd" />
        //	<Legend />
        //	<Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} />
        //	<Line type="monotone" dataKey="uv" stroke="#82ca9d" />
        //</LineChart>
        //</ResponsiveContainer>
        <div className="chart givemethefinger" onClick={props.onClick}>
            <div className="chart-internal">
                <div className="title">Received / Completed Cases - Last 7 Days</div>
                <div style={{ "width": "100%", "height": "14.6rem" }}>  {/*, backgroundColor: "lightgray" */}
                    <ResponsiveContainer>
                        <LineChart
                            data={props.data}
                            margin={{
                                top: 5, right: 10, left: 0, bottom: 0,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" strokeWidth={2} stroke="white" />
                            <XAxis dataKey="eventDate" tick={{ fontWeight: "bold", fontSize: "0.7rem" }} />
                            <YAxis tick={{ fontWeight: "bold", fontSize: "0.7rem" }} width={30}/>
                            <Tooltip />
                            <Line type="monotone" dataKey="completed" stroke="#ec008c" name="Completed" strokeWidth={2} activeDot={{ r: 8 }} />
                            <Line type="monotone" dataKey="received" stroke="#01837b" name="Recieved" strokeWidth={2} activeDot={{ r: 8 }} />
                            {/*<Area type="monotone" dataKey="uv" stroke="#8884d8" fill="#8884d8" />*/}
                        </LineChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    );
}

export default CompletedCases;